import { render, staticRenderFns } from "./ProjectStageDetail.vue?vue&type=template&id=8ec0cfb4&scoped=true"
import script from "./ProjectStageDetail.vue?vue&type=script&lang=js"
export * from "./ProjectStageDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectStageDetail.vue?vue&type=style&index=0&id=8ec0cfb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec0cfb4",
  null
  
)

export default component.exports